import React from "react"
import { withDynamicComponents } from "higher-order-components"
import { GlobalNavDropdown } from "components"
import GlobalNavOverlayBlock from "../global-nav-overlay"

const mapCMScomponents = ({ name, props }) => ({
  name: name === "Overlay" ? "GlobalNavOverlayBlock" : name,
  props
})

const GlobalNavDropdownBlock = props => <GlobalNavDropdown {...props} />

GlobalNavDropdownBlock.displayName = "NavDropdown" // @CMS-CHANGE Offers => GlobalNavDropdownBlock

export default withDynamicComponents({
  componentWhitelist: [GlobalNavOverlayBlock],
  mapInput: mapCMScomponents // @CMS-CHANGE in global nav Overlay => GlobalNavOverlayBlock
})(GlobalNavDropdownBlock)



// WEBPACK FOOTER //
// ./src/blocks/global-nav-dropdown/index.jsx